
import XButton from 'vux/src/components/x-button/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import { mapActions, mapState } from "vuex";
import GuideCover from "@/components/guideCover.vue";
export default {
name: "home",
directives: {
TransferDom,
},
data() {
return {};
},
methods: {
...mapActions(["showCoverAction"]),
jump(toName) {
if (toName == "play") {
this.$sa.re_activity({
name: "答题拼图",
event_type: "点击开始答题",
});
} else {
this.$sa.re_activity({
name: "答题拼图",
event_type: "点击我的红包",
});
}
if (!this.wxUserInfo.phone) {
this.$api.setStorage("strLogin", {
url: location.href,
from: "answer",
});
let registerUrl = "/html/newWechat.html#/register";
if (/sj-wx|doc\.jimijiayuan/.test(location.href)) {
registerUrl = "/html/clinical/index.html#/register";
}
this.$sa.setSaSession_href(this.$route, registerUrl);
} else {
if (toName == "hb") {
this.$router.push({
name: "myredpacket",
});
} else {
this.$router.push({
name: "play",
});
}
}
},
},
computed: {
...mapState({
wxUserInfo: (state) => state.wxUserInfo,
}),
},
components: {
XButton,
XDialog,
GuideCover,
},
mounted() {
this.$refs.home.style.height = document.body.clientHeight + "px";
sa.track(
"activity",
{
action: "vzb_dati2018",
type: "entry_home",
from: this.$route.query.channelFrom
? this.$route.query.channelFrom
: "yxvzb",
},
function () {}
);
},
};



// WEBPACK FOOTER //
// ./src/page/Home/index.vue